import { create } from 'zustand';

interface ManagePeriodVisitModalState {
  slug: string;
  isOpen: boolean;
  onManagePeriodVisitModalClose: () => void;
  onManagePeriodVisitModalOpen: (slug: string) => void;
}

export const useManagePeriodReportModalStore = create<ManagePeriodVisitModalState>(set => ({
  isOpen: false,
  slug: '',
  onManagePeriodVisitModalClose: () => set({ isOpen: false, slug: '' }),
  onManagePeriodVisitModalOpen: (slug: string) => set({ isOpen: true, slug }),
}));
